export const tableConfig = [
    {
        key: "job_id",
        label: "Jobpack ID",
        width: 3,
        sortable: true,
        sortAs: "string",
        keyType: "text",
    },
    {
        key: "urn",
        label: "  URN",
        width: 3,
        sortable: false,
        sortAs: "string",
        keyType: "text",
    },
    {
        key: "timestamp",
        label: "Jobpack Created",
        width: 3,
        sortable: true,
        sortAs: "timestamp",
        keyType: "text",
    },
    {
        key: "job_name",
        label: "Jobpack Name",
        width: 3,
        sortable: true,
        sortAs: "string",
        keyType: "text",
    },
    {
        key: "address",
        label: "Address",
        width: 2,
        sortable: true,
        sortAs: "string",
        keyType: "text",
    },

    {
        key: "start_date",
        label: "Start Date",
        width: 2,
        sortable: true,
        sortAs: "date",
        keyType: "text",
    },
    {
        key: "end_date",
        label: "End Date",
        width: 2,
        sortable: true,
        sortAs: "date",
        keyType: "text",
    },
];

export const userManagerTableConfig = [
    {
        key: "email",
        label: "Email Address",
    },
    {
        key: "contact_no",
        label: "Contact No.",
    },
    {
        key: "account_created",
        label: "Account Created",
    },
    {
        key: "last_active",
        label: "Last Active",
    },
    {
        key: "security_level",
        label: "Security Level",
    },
    {
        key: "access_level",
        label: "Access Level",
    },
];

//If user profile or user manager do not have this passed in they will revert to default (which is just contact_no and address)
export const userProfile = [
    { key: "contact_no", label: "Contact No.", type: "text", default: "" },
    // { key: "address", label: "Address", type: "text", default: "" },
    // {
    //     key: "user_type",
    //     label: "User Type",
    //     type: "dropdown",
    //     default: "Admin",
    //     opts: ["Admin", "Crew"]
    // }
    //EXAMPLE DROPDOWN {
    //     key: "test_key",
    //     label: "Test Lable",
    //     type: "dropdown",
    //     default: "No",
    //     opts: ["Yes", "No", "Maybe"]
    // }
];
